if (!window.wallesqueMotionInitialized) {
  window.wallesqueMotionInitialized = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-we-motion]');
    if (!button) return;
    const paused = button.getAttribute('aria-pressed') !== 'true';
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? 'Play artwork animation' : 'Pause artwork animation');
    button.closest('.we-hero').classList.toggle('is-paused', paused);
    button.querySelector('[data-we-pause]').hidden = paused;
    button.querySelector('[data-we-play]').hidden = !paused;
  });
}
